export default __webpack_public_path__ + "static/media/photo--lg--142.fca26da4.jpg";